import swal from "sweetalert";
import { getToken } from "../login";
import { api } from "../../Api/api";
import {
  CREATE_TYPE_OF_HELP_FAIL,
  CREATE_TYPE_OF_HELP_REQUEST,
  CREATE_TYPE_OF_HELP_SUCCESS,
  FETCH_TYPE_OF_HELP_FAIL,
  FETCH_TYPE_OF_HELP_REQUEST,
  FETCH_TYPE_OF_HELP_SUCCESS,
  UPDATE_TYPE_OF_HELP_FAIL,
  UPDATE_TYPE_OF_HELP_REQUEST,
  UPDATE_TYPE_OF_HELP_SUCCESS,
} from "../../ActionType/SurgeryType/SurgeryType";

export const getTypeOfHeAction = (name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      name,
    },
  };

  dispatch({
    type: FETCH_TYPE_OF_HELP_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get(`typeOfHelp`, config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: FETCH_TYPE_OF_HELP_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if (error.response.status == 422) {
      dispatch({
        type: FETCH_TYPE_OF_HELP_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const updateTypeOfHelpAction = (id, name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: UPDATE_TYPE_OF_HELP_REQUEST,
    payload: [],
  });
  try {
    const response = await api.put(`typeOfHelp/update/${id}`, { name }, config);
    const { status, data } = response;

    if (status == 200) {
      swal({
        title: "Good job!",
        text: "Type Of Help  was update Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch(getTypeOfHeAction());
      dispatch(getTypeOfHeAction());

      dispatch({
        type: UPDATE_TYPE_OF_HELP_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if (error.response.status == 422) {
      dispatch({
        type: UPDATE_TYPE_OF_HELP_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const createTypeOfHelpAction = (name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: CREATE_TYPE_OF_HELP_REQUEST,
    payload: [],
  });
  try {
    const response = await api.post("typeOfHelp/create", { name }, config);
    const { status, data } = response;

    if (status == 201) {
      swal({
        title: "Good job!",
        text: "Type Of Help  was saved Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch(getTypeOfHeAction());

      dispatch(getTypeOfHeAction());

      dispatch({
        type: CREATE_TYPE_OF_HELP_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if (error.response.status == 422) {
      dispatch({
        type: CREATE_TYPE_OF_HELP_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};
